import { Loader } from "@circle-react-uikit/Loader";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

export type MomentumModalProps = Readonly<
  Omit<ComponentPropsWithoutRef<typeof Modal>, "shouldShowCloseButton"> & {
    bodyClassName?: string;
    children?: ReactNode;
    description: string;
    headerClassName?: string;
    isLoading?: boolean;
    multiCTASectionLayout?: boolean;
    title: string;
  }
>;

export const MomentumModalUIKit = ({
  title,
  description,
  onClose,
  children,
  isLoading,
  multiCTASectionLayout = false,
  headerClassName,
  bodyClassName,
  ...rest
}: MomentumModalProps) => (
  <Modal onClose={onClose} {...rest}>
    <Modal.Overlay />
    <Modal.Content
      size={multiCTASectionLayout ? "lg" : undefined}
      className="!rounded-xl"
    >
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Loader aria-live="polite" aria-busy="true" />
        </div>
      )}
      <Modal.Header className={classNames("!justify-end", headerClassName)}>
        <Modal.HeaderActions>
          <Modal.CloseButton iconClassName="!text-default" onClick={onClose} />
        </Modal.HeaderActions>
      </Modal.Header>
      <Modal.Body
        className={classNames("px-8 pb-12", multiCTASectionLayout && "pb-8")}
      >
        <div className={classNames("flex flex-col gap-y-10", bodyClassName)}>
          <div className="flex flex-col gap-y-3 text-pretty px-4 text-center">
            <Modal.Title>{title}</Modal.Title>
            <Typography.BodyMd color="text-default">
              {description}
            </Typography.BodyMd>
          </div>
          <div className="flex w-full flex-col items-center">{children}</div>
        </div>
      </Modal.Body>
    </Modal.Content>
  </Modal>
);
